import { createMustacheTemplate } from '../Mustache/template'

/**
 * JavaScript 节点协议语法糖
 *
 * @example
 * javascript`
 *   return "javascript ${1}" + "javascript" + ${'1'}
 * `
 * ==>
 * {
 *   type: 'JavaScript',
 *   codeRaw: `
 *   return "javascript 1" + "javascript" + 1
 * `
 * }
 *
 * @example
 * javascript((variables, ...args) => {
 *   return "javascript" + variables.var1 + args[0]
 * })
 * ==>
 * {
 *   type: 'JavaScript',
 *   runner: (variables, ...args) => {
 *     return "javascript" + variables.var1 + args[0]
 *   }
 * }
 */
export const javascript = createMustacheTemplate('JavaScript', 'codeRaw')
